



export function NotNullUndef(input: any) {
    return input !== null && input !== undefined
}